module.exports = __webpack_public_path__ + "static/media/country_sy.e9b06867.webp";